<div>
  @if (data !== undefined && data.length > 0) {
    <img class="rounded-circle" [src]="data" />
  }
</div>
